import Pagination from './src/pagination.jsx'
import './styles/pagination.scss'

/* istanbul ignore next */
Pagination.install = function(Vue) {
  Vue.component(Pagination.name, Pagination)
}

export default Pagination
